export default __webpack_public_path__ + "static/media/structure_red.27df3002.svg";